export default __webpack_public_path__ + "static/media/small-arrow-icon.0caa0418.svg";